module.exports = __webpack_public_path__ + "assets/img/d3abc863d952518497ea3e61be68acf9.svg";